// extracted by css-extract-rspack-plugin
export default {"header":"header-KbrZTi","fact":"fact-sYayeW","icon":"icon-wUgVEa"};